import script from "./ChatForecastCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatForecastCard.vue?vue&type=script&setup=true&lang=js"

import "./ChatForecastCard.vue?vue&type=style&index=0&id=61262e0f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61262e0f"]])

export default __exports__